import { ErrorHandler } from '@angular/core';
import { RouterStateSerializer } from '@ngrx/router-store';
import { environment, production } from '../environments/environment';
import { CustomSerializer } from './custom-serializer';
import { GOOGLE_MAPS_API_KEY } from './shared/services/index';
import { RollbarService } from 'angular-rollbar';
import { NFErrorHandler, ERROR_LOGGING_SERVICE } from './error-handler/error-handler';
import { DevmodInterfaceModule, DevmodNoopModule } from '@devmod/interface';
import * as SDK from '@careapp/angular-sdk';
export function sdkFactory() {
    return SDK;
}
var devmod = DevmodNoopModule;
if (!production) {
    devmod = DevmodInterfaceModule;
}
export function windowFactory() {
    return window;
}
export function providers() {
    return [
        {
            provide: RouterStateSerializer,
            useClass: CustomSerializer
        },
        {
            provide: GOOGLE_MAPS_API_KEY,
            useValue: environment.GOOGLE_MAPS_API_KEY
        },
        {
            provide: ERROR_LOGGING_SERVICE,
            useClass: RollbarService
        },
        {
            provide: 'Window',
            useFactory: windowFactory
        }
    ];
}
export function productionProviders() {
    return providers().concat([
        {
            provide: ErrorHandler,
            useClass: NFErrorHandler
        }
    ]);
}
var ɵ0 = {
    smartLists: true
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
